module.exports = __webpack_public_path__ + "static/media/logo-big.005741a7.png";